import React, { useState, useEffect, useCallback } from 'react';
import { InputText, DropdownField } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import { useFormHandlers } from 'core/hooks/form/formHandlers';
import { Alert } from 'react-bootstrap';
import { MODAL_FORM_ERRORS } from 'core/constant/MODAL_FORM_ERRORS';

const EditCategoryModal = ({ show, category, handleClose, handleSave, updating, errors, requestError, categoryOptions }) => {
  const [formValues, setFormValues] = useState(category);
  const { handleChange } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(category);
  }, [category]);

  const handleSaveClick = useCallback(() => {
    handleSave({ ...formValues, id: category?.id });
  }, [formValues, category?.id, handleSave]);

  return (
    <BaseModalForm show={show} title={category?.id ? "Editar Categoría" : "Crear Categoría"} handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row">
        <div className="col-md-6 form-group">
          <InputText
            label="Título"
            name="title"
            value={formValues?.title}
            onChange={(e) => handleChange('title', e.target.value)}
            placeholder="Ingrese el título"
            error={errors.title}
          />
        </div>
        <div className="col-md-6 form-group">
          <DropdownField
            label="Categoría Padre"
            name="parent_id"
            value={formValues?.parent_id}
            options={categoryOptions}
            onChange={(e) => handleChange('parent_id', e.value)}
            placeholder="Seleccione la categoría padre"
            error={errors.parent_id}
          />
        </div>
        <div className="col-12 form-group mt-3">
          {requestError &&
            <Alert variant="danger">
              {requestError?.response?.data?.message ||
               MODAL_FORM_ERRORS.CATEGORY}
            </Alert>
          }
        </div>
      </div>
    </BaseModalForm>
  );
};

export default React.memo(EditCategoryModal);
